import { useEffect, useState } from 'react';

import Wall from './Wall';
import Waves from './Waves';
import Sun from './Sun';
import Logo from './Logo';

interface Props {}

const Background = (props: Props) => {
  const [isAnimated, setIsAnimated] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isWallAnimationFinished, setIsWallAnimationFinished] = useState(false);
  const [isWavesAnimationFinished, setIsWavesAnimationFinished] =
    useState(false);

  useEffect(() => {
    // const isAnimated = isHovered
    //   ? true
    //   : !isWallAnimationFinished || !isWavesAnimationFinished;
    setIsAnimated(false);
  }, [isHovered, isWallAnimationFinished, isWavesAnimationFinished]);

  const onMouseEnterBackground = () => {
    setIsHovered(true);
    setIsAnimated(false);
  };

  const onMouseLeaveBackground = () => {
    setIsWallAnimationFinished(false);
    setIsWavesAnimationFinished(false);
    setIsHovered(false);
  };

  return (
    <>
      <div className="background parallax-level-4">
        <Sun isAnimated={isAnimated} />
      </div>
      <div
        className="background parallax-level-3"
        onAnimationIteration={() => {
          setIsWallAnimationFinished(true);
        }}
      >
        <Wall isAnimated={isAnimated} />
      </div>
      <div className="background parallax-level-2">
        <Logo isAnimated={isAnimated} />
      </div>
      <div
        onMouseEnter={onMouseEnterBackground}
        onMouseLeave={onMouseLeaveBackground}
        onAnimationIteration={() => {
          setIsWavesAnimationFinished(true);
        }}
        className="background parallax-level-1"
      >
        <Waves isAnimated={isAnimated} />
      </div>
    </>
  );
};

export default Background;
